import AUTH_API from './modules/auth';

// 统一导出所有API
const API = {
  auth: AUTH_API
};

export default API; 